export default "__VITE_ASSET__BkJmB37d__"